import { Navigate, Route, useLocation } from 'react-router-dom';
import Home from '../../public/home/Home';
import Contact from '../../public/contact/Contact';
import Guide from '../../public/guide/Guide';
import GuideContact from '../../public/guide-contact/GuideContact';
import PrivacyPolicy from '../../public/legal/privacy/PrivacyPolicy';
import PrivacyPolicyOwner from '../../public/legal/privacy-owner/PrivacyPolicyOwner';
import Download from '../../public/download/Download';
import OwOwner from '../../public/ow-owner/OwOwner';
import PublicLayout from './layout';

const LegacyPaymentRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`/restaurant/payment-result${search}`} replace />;
};

export const publicRoutes = (
  <>
    <Route element={<PublicLayout />}>
      <Route index element={<Home />} />
      <Route path="contact" element={<Contact />} />
      <Route path="guide" element={<Guide />} />
      <Route path="guide/contact" element={<GuideContact />} />
      <Route path="privacy-policy" element={<PrivacyPolicy />} />
      <Route path="privacy-policy-owner" element={<PrivacyPolicyOwner />} />
      <Route path="download" element={<Download />} />
      <Route path="ow-owner" element={<OwOwner />} />
    </Route>
    <Route path="ow-owner/login" element={<Navigate to="/restaurant/login" replace />} />
    <Route path="ow-owner/settings" element={<Navigate to="/restaurant/settings" replace />} />
    <Route path="ow-owner/payment-result" element={<LegacyPaymentRedirect />} />
  </>
);
